import { Moment } from "moment";

import { TaskModel, Link } from "@teamprevent/common/task/taskActions/models";
import { ImmunisationTaskType } from "@teamprevent/common/consultations/models";
import { ImmunisationForCase } from "@teamprevent/common/immunisation/models";
import { AnsweredQuestionWithId } from "@teamprevent/common/model";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import { parseImmunisationForCase } from "../crud/ohCase/model";
import { AddTaskFormModel, parseTaskModel } from "../task/model";
import { IMMUNISATION_TASK_TYPES_OPTIONS } from "../crud/immunisationTypeTask/model";
import { LinkedOhCase } from "../crud/ohCase/model";
import { AddNextTaskFormModel } from "../tasks/models";
import { ImmunisationCreateModel } from "../immunisations/model";

export interface ImmunisationReviewResult {
    ohCaseId: string;
    tasks: TaskModel[];
    immunisations: ImmunisationForCase[];
    linkedOhCases?: LinkedOhCase[];
}

export interface FollowUpTaskModel {
    taskType: string;
    immunisationTypeTasks: string[] | null;
    dueDate?: Moment;
    notes?: string;
    taskCodeId?: string;
    assignedUsers?: Link[];
}

export const FOLLOW_UP_ACTIONS_OPTIONS = [
    ...IMMUNISATION_TASK_TYPES_OPTIONS.map(o => ({
        text: o.text,
        value: o.value,
        taskType: o.value,
        associatedWithImmunisation: o.associatedWithImmunisation,
        dueDateApplicable: o.dueDateApplicable
    })),
    {
        text: "Book Blood Test",
        value: "BookImmunisationBloodTestTask",
        taskType: ImmunisationTaskType.BloodTest,
        associatedWithImmunisation: true,
        dueDateApplicable: true
    },
    {
        text: "Book Vaccine",
        value: "BookImmunisationVaccineTask",
        taskType: ImmunisationTaskType.Vaccine,
        associatedWithImmunisation: true,
        dueDateApplicable: true
    },
    {
        text: "Chase Results",
        value: "ChaseImmunisationBloodTestResultsTask",
        taskType: ImmunisationTaskType.Results,
        associatedWithImmunisation: true,
        dueDateApplicable: true
    },
    {
        text: "Review Blood Test Result",
        value: "ReviewImmunisationBloodTestResultTask",
        taskType: ImmunisationTaskType.Results,
        associatedWithImmunisation: true,
        dueDateApplicable: true
    }
];

export function parseImmunisationReviewResult(result: ServerModelWithDateStrings<ImmunisationReviewResult>) {
    return {
        ...result,
        tasks: result.tasks.map(parseTaskModel),
        immunisations: result.immunisations.map(parseImmunisationForCase)
    };
}

export interface QuestionsData {
    questions: AnsweredQuestionWithId[];
}

export interface TasksData {
    tasks: { task: AddTaskFormModel; isValid: boolean }[];
}

export interface ImmunisationTasksData {
    tasks: { taskModel: AddNextTaskFormModel; immunisationTypeId: string }[];
}

export interface ImmunisationRecordsData {
    immunisations: { immunisationModel: ImmunisationCreateModel; immunisationTypeId: string }[];
}

export interface SaveImmunisationReviewModel {
    eTag?: string;
    questionsData: QuestionsData;
    tasksData: TasksData;
    immunisationTasksData: ImmunisationTasksData;
    immunisationRecordsData: ImmunisationRecordsData;
}

export interface ImmunisationReviewAutoSaveModel {
    id?: string;
    eTag?: string;
}
